import {CacheStateService} from "./CacheStateService";
import {ApplicationPropertiesState} from "../../../state/cache/ApplicationPropertiesState";
import {ApplicationPropertiesService} from "../../ApplicationPropertiesService";

export class ApplicationPropertiesStateService extends CacheStateService<ApplicationPropertiesState, {}> {
    protected async getNewStatePromise(refreshData: object, applicationPropertiesState: ApplicationPropertiesState): Promise<ApplicationPropertiesState> {
        const applicationPropertiesService = new ApplicationPropertiesService();
        const applicationProperties = await applicationPropertiesService.get();

        return new ApplicationPropertiesState(applicationProperties, false, true);
    }
}